import {useParams} from "react-router-dom";
import {Alert, Box} from "@mui/material";
import AgendaPrintPage from "./pages/agenda/AgendaPrintPage";
import FolioPrintPage from "./pages/folio/FolioPrintPage";
import ReservationConfirmationPrintPage from "./pages/reservationConfirmation/ReservationConfirmationPrintPage";

// Routes guest-facing print previews through the same renderer used by editor Preview mode.
const PrintoutPreview = () => {
    const {type} = useParams();

    switch (type) {
        case "agenda":
            return <AgendaPrintPage/>;
        case "folio":
            return <FolioPrintPage/>;
        case "reservationConfirmation":
            return <ReservationConfirmationPrintPage/>;
        default:
            return (
                <Box sx={{maxWidth: 720, mx: 'auto', p: 4}}>
                    <Alert severity={'info'}>
                        There is no printout preview for "{type}" yet.
                    </Alert>
                </Box>
            );
    }
}

export default PrintoutPreview;
